export default {
    currentCard:{}
}